import './service-worker-lifecycle.scss';
import { defineComponent } from 'vue';
import { interval } from 'rxjs';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

import { Event, serviceWorker$, States } from './register-service-worker';
import { FORCE_UPDATE_SERVICE_WORKER_TOPIC } from '@skinsoft/bus';

const CHECK_FOR_UPDATE_INTERVAL = 60e3;

export const ServiceWorkerLifecycle = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./service-worker-lifecycle.html'),
    data() {
        return {
            bullhornIcon: faBullhorn,
            updateInProgress: false,
            updateFound: false,
            serviceWorkerState: null as any as States,
            registration: null as any as ServiceWorkerRegistration,
        }
    },
    created() {
        this.subscribeTo(serviceWorker$, (event: Event) => {
            if (event.registration) {
                this.registration = event.registration as ServiceWorkerRegistration;
            }

            this.updateFound = event.state === States.UPDATED;
        });
        this.subscribeToBus('check_for_update_topic', () => {
            this.checkForUpdate();
        });
        this.subscribeTo(interval(CHECK_FOR_UPDATE_INTERVAL), () => {
            this.checkForUpdate();
        });
        this.subscribeToBus(FORCE_UPDATE_SERVICE_WORKER_TOPIC, () => {
            this.forceUpdateServiceWorker()
        })
    },
    methods: {
        update() {
            this.updateInProgress = true;
            // @ts-ignore
            location.reload(true);
        },
        checkForUpdate() {
            if (!this.registration) {
                return;
            }

            this.registration.update();
        },
        forceUpdateServiceWorker() {
            if(this.registration) {
                if(this.registration.waiting) {
                    this.registration.waiting.postMessage({ action: 'skipWaiting' })
                }
            }
        },
    },
})
